import React from "react";
import ImageContainer from "./../TiledCardPages/components/imageContainer.jsx";
import LegendItemForm from "./LegendItemForm.jsx";

const LegendItem = ({
  legendItem,
  singleType,
  pageOptions,
  onPocketTypeChange,
  onOptionClick,
}) => {



  const {
    DisplayName,
    URL,
    SignType,
    PocketTypeAttribute,
    ImageURL,
    SignSize,
    ProdType,
    ProdOptionId,
    ProductSuffix,
    index
  } = legendItem;


  
const handleRadioChange = (event, signType) => {
  const selectedOption = event.target;

  onPocketTypeChange(selectedOption, signType);
  onOptionClick(event);
};

  const { FirstRadioOptionAttributeId, SecondRadioOptionAttributeId } =
    pageOptions;

  const hasPocketType = PocketTypeAttribute && PocketTypeAttribute != null;
  const baseVal = ProductSuffix + "-" + SignType + "-" + SignSize + "-";
  const pocketType = hasPocketType ? PocketTypeAttribute.AttributeId : "";

  const id = hasPocketType ? baseVal + pocketType : "";

  const isVinylSign = SignType != "Marathon" && SignType != "Mesh";

  
  const loadingType = index < 3 ? "eager" : "lazy";
  return (
    <div
      className={`legended-sign-panel ${
        singleType ? "single col-xs-12 col-md-8" : "double col-xs-6 col-md-5"
      }`}
      id={id}
    >
      <div className="signBox">
        <div className="content-container">
          <h2 className="legend-title col-xs-12">
            <a href={URL}>{DisplayName}</a>
          </h2>

          <div className="col-xs-12 col-md-5">
            <a href={URL}>
              <ImageContainer
                  src={ImageURL}
                  alt={`${DisplayName} sign`}
                  className="cld-responsive signbox-image"
                  loading={loadingType}
                  width={150}
                  height={194}
              />
            </a>
          </div>
          <div className="putalegend product-quantity col-xs-12 col-md-7">
            <div className="put-a-legend-text">
              {SignSize}" <b>{SignType}</b> {ProdType}
            </div>
            {PocketTypeAttribute && isVinylSign && (
              <div>
                <div className="pocket-type-text"> Select Pocket Type</div>
                <label className="roll-up-options">
                  <input
                    type="radio"
                    className="product-attribute-radio"
                    id={`option-${ProdOptionId}-${FirstRadioOptionAttributeId}`}
                    name={`option-${ProdOptionId}`}
                    checked={
                      PocketTypeAttribute.AttributeId ===
                      FirstRadioOptionAttributeId
                    }
                    value={FirstRadioOptionAttributeId}
                    onChange={(e) => handleRadioChange(e, SignType)}
                  />
                  Plastic Pockets
                </label>
                <label className="roll-up-options">
                  <input
                    type="radio"
                    className="product-attribute-radio"
                    id={`option-${ProdOptionId}-${SecondRadioOptionAttributeId}`}
                    name={`option-${ProdOptionId}`}
                    checked={
                      PocketTypeAttribute.AttributeId ===
                      SecondRadioOptionAttributeId
                    }
                    value={SecondRadioOptionAttributeId}
                    onChange={(e) => handleRadioChange(e, SignType)}
                  />
                  Sewn Pockets
                </label>
              </div>
            )}
            <span className="legendedProductAddToCart-Quantity">
              <LegendItemForm item={legendItem} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegendItem;
